import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Label } from "@client.components/Modal";
import { useSelector } from "react-redux";
import { makeSalaryRanges } from "@client.pages/Settings/reducer";
import Dropdown from "@client.components/Dropdown";
import { getRangeTitle } from "./utils";

const DropdownSalaryRange = ({ error, selectedSalaryRangeId, onSelect }) => {
  const { t } = useTranslation();
  const salaryRanges = useSelector(makeSalaryRanges);

  return (
    <>
      <Label term="components.UserManagementContent.salaryRange" />
      <Dropdown
        id="salary-ranges"
        error={error}
        items={salaryRanges.map((s) => ({
          value: s.id,
          label: getRangeTitle(t, s),
        }))}
        valueKey="value"
        labelKey="label"
        placeholder={t(
          "components.UserManagementContent.placeholder.salaryRange"
        )}
        defaultValue={selectedSalaryRangeId}
        onPrepareValue={(val) => parseInt(val)}
        onSelect={onSelect}
      />
    </>
  );
};

DropdownSalaryRange.defaultValue = {
  selectedRole: undefined,
};

DropdownSalaryRange.propTypes = {
  error: PropTypes.array,
  selectedSalaryRangeId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};

export default DropdownSalaryRange;
